import { Component, inject } from '@angular/core';
import { SessionTimeoutService } from '../../../core/services/session-timeout.service';

/**
 * Idle-session warning shown by {@link SessionTimeoutService}. Rendered once at
 * the app root; visibility is driven entirely by the service's signals.
 */
@Component({
  selector: 'app-session-timeout-dialog',
  standalone: true,
  template: `
    @if (session.warningVisible()) {
      <div class="ir-modal-backdrop">
        <div class="ir-modal" style="max-width:400px" role="alertdialog" aria-modal="true">
          <div class="ir-modal__header">
            <span class="ir-modal__title">Are you still there?</span>
          </div>
          <div class="ir-modal__body">
            <p style="margin:0 0 10px;color:var(--text-secondary);font-size:0.85rem">
              You've been inactive for a while. For your security you'll be signed
              out automatically in
            </p>
            <div style="text-align:center;font-size:1.9rem;font-weight:600;font-variant-numeric:tabular-nums;color:var(--accent)">
              {{ session.countdownLabel() }}
            </div>
          </div>
          <div class="ir-modal__footer">
            <button class="ir-btn ir-btn--ghost ir-btn--sm" (click)="session.logoutNow()">
              Log out
            </button>
            <button class="ir-btn ir-btn--primary ir-btn--sm" (click)="session.continueSession()">
              Stay signed in
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class SessionTimeoutDialogComponent {
  readonly session = inject(SessionTimeoutService);
}
